"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const PreviewView_1 = require("../PreviewView");
const EditorView_1 = require("../EditorView");
exports.EmailCanvasSideBySideView = () => {
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.Row, { osysName: "EmailCanvasSideBySideView" },
        react_2.default.createElement(react_1.OsmosysFlexFrame.Col, { osysName: "EmailCanvasSideBySideView.Col" },
            react_2.default.createElement(EditorView_1.EmailCanvasEditorView, null)),
        react_2.default.createElement(react_1.OsmosysFlexFrame.Col, { osysName: "EmailCanvasSideBySideView.Col" },
            react_2.default.createElement(PreviewView_1.EmailCanvasPreviewView, null))));
};
//# sourceMappingURL=index.js.map